module.exports = "<ckeditor [(ngModel)]=\"ckeditorContent\" [config]=\"{uiColor: '#99000'}\" [readonly]=\"false\" (change)=\"onChange($event)\" (ready)=\"onReady($event)\"\n  (focus)=\"onFocus($event)\" (blur)=\"onBlur($event)\" debounce=\"500\">\n</ckeditor>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/custom-ckeditor/custom-ckeditor.component.html
// module id = ./src/app/components/custom-ckeditor/custom-ckeditor.component.html
// module chunks = main